import { render, staticRenderFns } from "./AdminAssignCommittee.vue?vue&type=template&id=0b1d9b12&scoped=true"
import script from "./AdminAssignCommittee.vue?vue&type=script&lang=js"
export * from "./AdminAssignCommittee.vue?vue&type=script&lang=js"
import style0 from "./AdminAssignCommittee.vue?vue&type=style&index=0&id=0b1d9b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d9b12",
  null
  
)

export default component.exports